import * as Yup from 'yup'
import { cloneDeep } from 'lodash-es'
import { DOCUMENT_TYPES, thresholds } from './types'

export enum THRESHOLDS_FORM_FIELDS {
  ID = 'id',
  FIELD_KEY = 'fieldKey',
  MIN_CONFIDENCE_SCORE = 'minConfidenceScore',
  DOCUMENT_TYPE = 'documentType'
}

export interface IThresholdsForm {
  [THRESHOLDS_FORM_FIELDS.ID]: string;
  [THRESHOLDS_FORM_FIELDS.FIELD_KEY]: string;
  [THRESHOLDS_FORM_FIELDS.MIN_CONFIDENCE_SCORE]: string;
  [THRESHOLDS_FORM_FIELDS.DOCUMENT_TYPE]: DOCUMENT_TYPES;
}

export const ThresholdsFormLabels: Record<string, string> = {
  [THRESHOLDS_FORM_FIELDS.FIELD_KEY]: 'Field Key',
  [THRESHOLDS_FORM_FIELDS.MIN_CONFIDENCE_SCORE]: 'Minimum Confidence Score',
  [THRESHOLDS_FORM_FIELDS.DOCUMENT_TYPE]: 'Document Type'
}

export const defaultThresholdsFormValues: IThresholdsForm = {
  [THRESHOLDS_FORM_FIELDS.ID]: '',
  [THRESHOLDS_FORM_FIELDS.FIELD_KEY]: '',
  [THRESHOLDS_FORM_FIELDS.MIN_CONFIDENCE_SCORE]: '',
  [THRESHOLDS_FORM_FIELDS.DOCUMENT_TYPE]: DOCUMENT_TYPES.PAYMENT_REMITTANCE
}

export const getInitialThresholdsFormValueFromResponse = (
  response: thresholds
): IThresholdsForm => {
  const {
    id = '',
    fieldKey = '',
    minConfidenceScore = '',
    documentType = DOCUMENT_TYPES.PAYMENT_REMITTANCE
  } = response

  const formInitialValues: IThresholdsForm = {
    [THRESHOLDS_FORM_FIELDS.ID]: id,
    [THRESHOLDS_FORM_FIELDS.FIELD_KEY]: fieldKey,
    [THRESHOLDS_FORM_FIELDS.MIN_CONFIDENCE_SCORE]: minConfidenceScore,
    [THRESHOLDS_FORM_FIELDS.DOCUMENT_TYPE]: Object.values(
      DOCUMENT_TYPES
    ).includes(documentType as DOCUMENT_TYPES)
      ? (documentType as DOCUMENT_TYPES)
      : DOCUMENT_TYPES.PAYMENT_REMITTANCE
  }

  return cloneDeep(formInitialValues)
}

export const thresholdsValidationSchema = Yup.object().shape({
  [THRESHOLDS_FORM_FIELDS.FIELD_KEY]: Yup.string().required(
    'Field Key is required'
  ),
  [THRESHOLDS_FORM_FIELDS.MIN_CONFIDENCE_SCORE]: Yup.number()
    .typeError('Confidence Score must be a number')
    .moreThan(0, 'Confidence Score must be greater than 0')
    .max(99, 'Confidence Score must not be more than 99')
    .required('Confidence Score is required'),

  [THRESHOLDS_FORM_FIELDS.DOCUMENT_TYPE]: Yup.mixed<DOCUMENT_TYPES>().required(
    'Document Type is required'
  )
})
